import React from "react";
import { useSettingsStore } from "../../store/tenantStore";
import { getPresetById } from "../../config/themePresets";

export default function Header(_props: { showHouseSelector?: boolean }) {
  return null;
}

export function Footer() {
  const settings = useSettingsStore((state) => state.settings);
  const activeTheme = getPresetById(settings?.colorTheme ?? "301io");
  const brandName = activeTheme.brandName || activeTheme.name;
  
  return (
    <footer className="border-t bg-secondary/30">
      <div className="mx-auto max-w-7xl px-6 lg:px-8 py-12">
        <div className="flex flex-col md:flex-row items-center justify-between gap-4">
          <div className="flex items-center gap-2.5">
            <div 
              className="h-6 w-6 rounded-md" 
              style={{ backgroundColor: `hsl(${activeTheme.primary})` }}
            />
            <span className="text-sm font-normal tracking-tight">
              {brandName}
            </span>
          </div>
          <p className="text-sm text-muted-foreground">
            &copy; {new Date().getFullYear()} {brandName}. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}
